import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import styled from '@emotion/styled';

interface StyledChatBarItemProps {
    active?: boolean;
}

export const StyledChatBarItem = styled.div<StyledChatBarItemProps>`
    position: relative;
    cursor: pointer;
    display: flex;
    padding: 14px;
    width: 100%;

    ${(props) =>
        props.active &&
        `
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 4px;
            background: #F3F1FF;
        `}

    ${(props) => {
        if (props.active) {
            return `
                &:before {
                    transform: translateY(-50%);
                    background-color: #4A52BB;
                    border-radius: 4px;
                    position: absolute;
                    height: 60px;
                    content: "";
                    left: -12px;
                    width: 3px;
                    top: 50%;
                };
            `;
        }
    }}
`;

export const StyledArrowForwardIosRoundedIcon = styled(ArrowForwardIosRoundedIcon)`
    transform: translateY(-50%);
    position: absolute;
    right: -18px;
    top: 50%;
`;

export const StyledChatBarItemAvatar = styled.img`
    border-radius: 50%;
    object-fit: cover;
    height: 40px;
    width: 40px;
`;

export const StyledChatBarItemTitle = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 16px;
`;

export const StyledChatBarItemContent = styled.div`
    width: calc(100% - 100px);
    align-items: flex-start;
    flex-direction: column;
    margin: 0 16px;
    display: flex;
`;

export const StyledChatBarItemContentText = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px;
    color: #686868;
`;

export const StyledChatBarItemNotification = styled.div`
    justify-content: center;
    justify-self: flex-end;
    align-items: center;
    background: #f3a712;
    border-radius: 3px;
    align-self: center;
    padding: 2px 12px;
    color: #ffffff;
    display: flex;
    height: 20px;
`;
